var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.facets && _vm.facets.length > 0,
          expression: "facets && facets.length > 0",
        },
      ],
      staticClass: "filter-wrapper",
      class: "filter-wrapper__" + _vm.filterType,
    },
    [
      _c(
        "portal-mobile",
        { attrs: { "portal-to": "mobile-filter", breakpoint: 992 } },
        [
          _vm._l(_vm.facets, function (facet) {
            return _c("item-filter", {
              key: facet.id,
              attrs: {
                "filter-type": _vm.filterType,
                "is-mobile": _vm.isMobile,
                facet: facet,
              },
            })
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectedFacets && _vm.selectedFacets.length > 0,
                  expression: "selectedFacets && selectedFacets.length > 0",
                },
              ],
              staticClass: "item-filter__clear-all",
              on: {
                click: function ($event) {
                  return _vm.clearAllFacets()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "15",
                  },
                },
                [
                  _c("use", {
                    attrs: {
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      "xlink:href": "#svg-reset",
                    },
                  }),
                ]
              ),
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$translate("OD3dprimaV2::Template.categoryResetFilters")
                  ) +
                  "\n        "
              ),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }